import { Link } from 'components/Elements';
import { Head } from 'components/Head';
import PropTypes from 'prop-types';
import logoWord from 'assets/logo-reverse.svg';
import logo from 'assets/logo512.png';

export const Layout = ({ children, title }) => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Head title={title} />

      {/* Background Wrapper with Ethnic Image */}
      <div className="min-h-screen flex items-center justify-center p-4 sm:p-6 md:p-10">
        {/* Inner Container */}
        <div className="w-full max-w-8xl h-[90vh] bg-[#383D4E] text-white rounded-2xl shadow-2xl px-6 py-12 flex flex-col justify-between">
          <div className=""></div>
          <div className="">
            <Link to="/" className="flex flex-col items-center justify-center mb-6">
              <img src={logoWord} alt="Justknow" className="h-24 w-auto" />
            </Link>

            <h2 className="text-center text-xl font-extrabold text-gray-200 mb-6">{title}</h2>
            <div className="max-w-md mx-auto shadow rounded-3xl bg-[#3d4255] p-8">{children}</div>
          </div>

          {/* Footer */}
          <div className="mt-10 text-xs text-gray-400 text-center border-t border-gray-600 pt-4 space-y-1">
            <div>© {currentYear} NorthUp Limited. All rights reserved.</div>
            <div>
              This platform complies with industry standards for data protection, accessibility, and
              information security. By using this service, you agree to our{' '}
              <a href="/terms" className="underline hover:text-white">
                Terms of Service
              </a>{' '}
              and{' '}
              <a href="/privacy" className="underline hover:text-white">
                Privacy Policy
              </a>
              .
            </div>
            <div>
              For questions or legal inquiries, contact{' '}
              <a href="mailto:compliance@northup.go.ug" className="underline hover:text-white">
                compliance@northup.go.ug
              </a>
              .
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
};
